/* eslint-disable react/no-array-index-key */
import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import { useGate } from 'effector-react';
import flexBoxHack from '@utils/flexBoxHack';
import LibModalList from '../layouts/LibModalList';
import LibModalListBody from '../layouts/LibModalListBody';
import { $libSelectedApi } from '../stores/libSelected';
import { sysIconList } from './sysIconList';
import { IconItem } from './IconItem';
import { LibItemsGate } from '../stores/libState';

const filterItems: { name: string }[] = [
  { name: '全部' },
  { name: '静态图标' },
  { name: '动态图标' },
];

export function ListSysIcons({ staticOnly = false }: { staticOnly?: boolean }) {
  const [typeIndex, setTypeIndex] = useState(0);
  const [filterIndex, setFilterIndex] = useState(0);
  const items = useMemo(() => {
    const list = sysIconList[typeIndex]?.list ?? [];
    if (filterIndex === 1 || staticOnly) {
      return list.filter((x) => x.frame === 1);
    }
    if (filterIndex === 2) {
      return list.filter((x) => x.frame > 1);
    }
    return list;
  }, [typeIndex, filterIndex]);

  useGate(LibItemsGate, items);

  return (
    <LibModalList>
      <div className="bg-white-light px-15 pt-15">
        <TagGroup
          title="类别"
          items={sysIconList}
          activeIndex={typeIndex}
          onClick={(index) => {
            $libSelectedApi.clear();
            setTypeIndex(index);
          }}
        />
        {!staticOnly && (
          <TagGroup
            title="类型"
            items={filterItems}
            activeIndex={filterIndex}
            onClick={(index) => {
              $libSelectedApi.clear();
              setFilterIndex(index);
            }}
          />
        )}
      </div>
      <LibModalListBody>
        <Scrollbars>
          <div className="flex flex-wrap items-center justify-between py-15 px-10">
            {items.map((x, i) => (
              <IconItem data={x} key={x.url} index={i} />
            ))}
            {flexBoxHack(90, 7)}
          </div>
        </Scrollbars>
      </LibModalListBody>
    </LibModalList>
  );
}

export function TagGroup({
  title,
  items,
  activeIndex,
  onClick,
}: {
  title: string;
  items: { name: string }[];
  activeIndex: number;
  onClick: (number: number) => void;
}) {
  return (
    <div className="mb-10 flex font-medium">
      <div className="flex-shrink-0">{`${title}：`}</div>
      <div className="ml-10 flex flex-wrap items-center text-black-gray">
        {items.map((x, i) => (
          <div
            key={x.name}
            className={classNames('mr-15 mb-5 cursor-pointer hover:text-blue', {
              'text-blue': activeIndex === i,
            })}
            onClick={() => {
              if (i !== activeIndex) onClick(i);
            }}
          >
            {x.name}
          </div>
        ))}
      </div>
    </div>
  );
}
